/**
 * Please do not modify this path until we are able to optimize memory usage for exports from the bloomreach-seo-solution library
 */
import { getThematicData } from '@seo/bloomreach-seo-solution/lib/public-interface/thematic-interface';
import { logInfo } from '@seo/logger';
import { Request } from 'express';
import { Brands } from '@core-ui/react-stitch';
import { Market } from '@core-ui/app-state-provider';
import { PageData } from '../../types/app';
import { logThematicError } from '../../../util/logThematicError';
import { ThematicResponse } from '../../types/thematic-response';
import logThematicInfo from '../../../util/logThematicInfo';
import { getUniqueIds } from '../../../util/request-helpers';
import { ThematicError } from '../../../util/thematicError';

type GetPageDataProps = {
  brand: Brands,
  market: Market,
  facetQueryArray?: string[],
  theme: string,
  req?: Request
  efq?: string[];
};

const getPageData = async({ brand, market, facetQueryArray, theme, req, efq }: GetPageDataProps): Promise<PageData> => {
  const url = globalThis?.window
    ? `${window?.location?.origin}${window?.location?.pathname}${window?.location?.search}`
    : `${req?.headers.origin}${req?.originalUrl}`;

  const queryParams = url.split('?')[1];
  const debug = queryParams?.includes('debug=true') ? 'true' : 'false';

  const { requestId, correlationId, vcapRequestId, requestTimeStamp } = getUniqueIds(req);

  const params = {
    brand,
    debug,
    efq,
    facetQueryArray,
    referrer: req?.headers.referer,
    requestId,
    theme,
    url,
    correlationId,
    vcapRequestId,
    requestTimeStamp
  };

  logInfo({
    type: 'Thematic API Request',
    log: `Requesting data for theme: ${theme}`,
    ...((facetQueryArray?.length > 0) && { facetQueryString: facetQueryArray.toString() }),
    ...params
  });

  try {
    const rawThematicApiData: ThematicResponse = await getThematicData(params);

    if (rawThematicApiData.response.numFound <= 0) {
      const error = new ThematicError('Empty Products', 404, theme, requestId);

      logThematicError(error, theme, brand, market, url);
    } else {
      logThematicInfo({
        type: 'Thematic API Request',
        log: `Successfully retrieved thematic data for theme: ${theme}`,
        source: rawThematicApiData.source,
        ...((facetQueryArray?.length > 0) && { facetQueryString: facetQueryArray.toString() }),
        ...params
      });
    }

    return { rawThematicApiData };
  } catch (error) {
    const msg = error?.errorMessage?.toLowerCase() || error?.message?.toLowerCase() || '';

    if (msg.includes('timeout')) {
      error.status = 200;
      error.requestId = requestId;
      return { rawThematicApiData: { error } };
    }

    error.theme = theme;
    error.requestId = requestId;
    error.status = error.statusCode;
    throw error;
  }
};

export default getPageData;
